import React, { Component } from "react";
import { Navigate } from "react-router-dom";

import { withRouter } from '../with-router';
import AuthService from "../services/auth";
import { exitPath } from "../context/RemoteLaunchContext";

class Logout extends Component {
    constructor(props) {
        super(props);

        this.state = {
            redirect: null,
        }
    }

    componentDidMount(){
        localStorage.removeItem("user");
        localStorage.removeItem("demo_user");
        localStorage.removeItem("demo1_user");
        AuthService.logout();
        // WEB-410 -- a web player logging out is a finished visit, not a
        // staff member signing off.
        this.setState({ redirect: { path: exitPath(), state: null } });
    }

    render() {
        if (this.state.redirect) {
            return <Navigate to={this.state.redirect.path} state={this.state.redirect.state} />
        }

        return (
            <div>Logging out...</div>
        );
    }
}

export default withRouter(Logout);